(function($) {
    document.addEventListener('DOMContentLoaded', function() {

        /* Fixing admin panel offset */
        document.documentElement.setAttribute('style', 'margin-top: 0 !important');
        /* END Fixing admin panel offset */

        const bonuserCollectionSwitcherBlocks = document.querySelectorAll('.sidebar__bonuser-collection-block');
        if (bonuserCollectionSwitcherBlocks.length) {
            for (let i = 0; i < bonuserCollectionSwitcherBlocks.length; i++) {
                const bonuserCollectionSwitchers = bonuserCollectionSwitcherBlocks[i].querySelectorAll('.sidebar__bonuser-collection_switcher-item');
                const bonuserCollectionItems = bonuserCollectionSwitcherBlocks[i].querySelectorAll('.sidebar__bonuser-collection-item');

                if (bonuserCollectionSwitchers.length && bonuserCollectionItems.length) {
                    for (let j = 0; j < bonuserCollectionSwitchers.length; j++) {
                        bonuserCollectionSwitchers[j].addEventListener('click', () => {
                            resetCollectionActive(bonuserCollectionSwitchers, bonuserCollectionItems);

                            if (!bonuserCollectionSwitchers[j].classList.contains('active')) {
                                bonuserCollectionSwitchers[j].classList.add('active');
                                bonuserCollectionItems[j].classList.add('active');
                            }
                        });
                    }
                }
            }
        }

        function resetCollectionActive(switchers, items) {
            if (switchers.length && items.length) {
                for (let i = 0; i < switchers.length; i++) {
                    if (switchers[i].classList.contains('active')) {
                        switchers[i].classList.remove('active');
                        items[i].classList.remove('active');
                    }
                }
            }
        }

        /**
         * Review counter animation
         */
        const counter = document.querySelector("#review-counter");
        function init() {
            let duration = 2000;
            let start = 0;
            let value = 0;
            let begin = 0;
            let target = parseInt(counter.innerHTML);
            function startAnim(timestamp) {
                start = timestamp;
                end = start + duration;
                draw(timestamp);
            }
            function draw(now) {
                if (now >= start + duration) {
                    counter.innerHTML = target;
                    return;
                }
                let progress = (now - start) / duration;
                let val = easeInOutCubic(progress);
                let value = begin + (target - begin) * val;
                counter.innerHTML = value.toFixed(0);
                document.documentElement.style.setProperty("--left", value*0.5 + "px");

                // console.log(progress, begin, end);

                requestAnimationFrame(draw);
            }
            requestAnimationFrame(startAnim);
        }

        if (counter) {
            init();
        }

        function easeInOutCubic(t){
            {return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
        }


        /**
         * Dynamic size of images
         */
        const articleFooterLogo = document.querySelector('.article-footer__logo img');
        addImageSizeProperty([articleFooterLogo]);

        const contactHeadingBg = document.querySelector('.contact__heading-bg');
        addImageSizeProperty([contactHeadingBg]);

        const contentSectionImg = document.querySelectorAll('.content-section img');
        addImageSizeProperty(contentSectionImg);

        const lastSeoVBlocImg = document.querySelector('.last-seo-block__row-right img');
        addImageSizeProperty([lastSeoVBlocImg]);

        function addImageSizeProperty(images, callback) {
            if (images.length && window.innerWidth >= 992) {
                let styleElem = document.createElement('style');
                let styleInnerText = "";

                styleInnerText += "@media screen and (min-width: 992px) {";

                for (let i = 0; i < images.length; i++) {
                    if (!images[i] || images[i].clientWidth === 0) return;

                    let width = (images[i].clientWidth / 1457 * 100);
                    let customClass = width + "_" + Math.random() * 100 + "_" + Math.random() * 100;
                    customClass = customClass.replaceAll('.', '_');

                    styleInnerText += "[data-image-id='" + customClass + "'] {width: " + width + "vw}";

                    images[i].setAttribute('data-image-id', customClass);
                }

                styleInnerText += "}";

                styleElem.innerText = styleInnerText;
                document.body.append(styleElem);

                if (typeof callback == 'function') callback();
            }
        }

        /**
         * Header lang
         */
        const header_mobile_lang = document.querySelector('.header__lang');
        if (header_mobile_lang) {
            document.addEventListener('mouseup', function (e) {
                let container = $(header_mobile_lang);

                if (container.has(e.target).length !== 0) {
                    if (!container.hasClass('open')) {
                        container.addClass('open');
                    } else {
                        container.removeClass('open');
                    }
                } else {
                    container.removeClass('open');
                }
            });
        }

        /**
         * Header-search trigger
         */
        const header_search_trigger = document.querySelector('.header__search-trigger');
        const header_search_close = document.querySelector('.header-search-panel__label-close');
        const header_search_panel = document.querySelector('.header-search-panel');
        const header_search_input = document.querySelector('.header-search-panel__input');
        if (header_search_trigger && header_search_close) {
            header_search_trigger.addEventListener('mouseup', searchTriggerHandler);
            header_search_close.addEventListener('mouseup', searchTriggerHandler);
        }

        function searchTriggerHandler() {
            if (!header_search_panel.classList.contains('open')) {
                header_search_panel.classList.add('open');
                header_search_input.focus();
            } else {
                header_search_panel.classList.remove('open');
            }
        }

        /**
         * Mobile menu handler
         */
        const headerMobileMenuTrigger = document.querySelector('.header__trigger-mobile-menu');
        const menu = document.querySelector('.header-mobile');
        if (headerMobileMenuTrigger && menu) {
            headerMobileMenuTrigger.addEventListener('click', () => {
                if (!menu.classList.contains('open')) {
                    menu.classList.add('open');
                } else {
                    menu.classList.remove('open');
                }

                if (!headerMobileMenuTrigger.classList.contains('active')) {
                    headerMobileMenuTrigger.classList.add('active');
                } else {
                    headerMobileMenuTrigger.classList.remove('active');
                }
            });
        }

        /**
         * Fixed Header
         */
        let header = $('header.header'),
            scrollPrev = 0;

        window.addEventListener('load', header_is_fixed);
        window.addEventListener('scroll', header_is_fixed);

        function header_is_fixed() {
            let scrolled = $(window).scrollTop();

            if (menu.classList.contains('open')) return;

            if ( scrolled >= 100 && scrolled > scrollPrev ) {
                header.addClass('scrollingDown');
            } else if (scrolled < 100) {
                header.removeClass('scrollingDown');
            } else {
                header.removeClass('scrollingDown');
            }

            scrollPrev = scrolled;
        }



        /**
         * Mobile sub-menu handler
         */
        const itemsWithSubmenu = document.querySelectorAll('.header-mobile__menu-item.menu-item-has-children');
        if (itemsWithSubmenu.length) {
            let canToggle = true;

            for (let i = 0; i < itemsWithSubmenu.length; i++) {
                const trigger = itemsWithSubmenu[i].querySelector(' .submenu-trigger');
                if (trigger) {
                    trigger.addEventListener('click', () => {
                        headerMobileSubmenuHandler(trigger, itemsWithSubmenu[i]);
                    });
                }
            }

            function headerMobileSubmenuHandler(trigger, parent) {
                const submenu = parent.querySelector('.header-mobile-submenu');

                if (!trigger.classList.contains('active')) {
                    trigger.classList.add('active');
                    $(submenu).slideDown(300, function () {
                        canToggle = true;
                    });
                } else {
                    trigger.classList.remove('active');
                    $(submenu).slideUp(300, function () {
                        canToggle = true;
                    });
                }

                canToggle = false;
            }
        }
    });

    if ($('.nav__link__wrapper').length > 0) {
        var contentContainer = document.querySelector('.wrapper-main');

        var headings = contentContainer.querySelectorAll('[data-anchor="1"]');

        var tocContainer = document.querySelector('.nav__link__wrapper');

        var ul = document.createElement('ul');
        ul.setAttribute('id', 'tocList');
        ul.setAttribute('class', 'sidenav');

        var idCounter = 1;

        for (i = 0; i <= headings.length - 1; i++) {
            var id = 'id' + idCounter;
            idCounter++;

            var level = headings[i].localName.replace("h", "");

            var title = headings[i].innerHTML;

            headings[i].setAttribute("id", id);

            var li = document.createElement('li');

            li.setAttribute('class', 'sidenav__item');

            var a = document.createElement('a');

            a.setAttribute("href", "#" + id);

            a.innerHTML = title;

            if (level == 1) {
                li.appendChild(a);

                ul.appendChild(li);
            } else if (level == 2) {
                child = document.createElement('ul');

                child.setAttribute('class', 'sidenav__sublist__2');
                li.appendChild(a);
                child.appendChild(li);
                ul.appendChild(child);
            } else if (level == 3) {
                grandchild = document.createElement('ul');
                grandchild.setAttribute('class', 'sidenav__sublist__3');
                li.appendChild(a);
                grandchild.appendChild(li);
                child.appendChild(grandchild);
                console.log(child);
            } else if (level == 4) {
                great_grandchild = document.createElement('ul');
                great_grandchild.setAttribute('class', 'sidenav__sublist__4');
                li.append(a);
                great_grandchild.appendChild(li);
                grandchild.appendChild(great_grandchild);
            }
        }

        tocContainer.appendChild(ul);

        var links = tocContainer.getElementsByClassName("sidenav__item");
        links[0].classList.add('current');

        for (var i = 0; i < links.length; i++) {
            links[i].addEventListener("click", function () {
                var current = document.getElementsByClassName("current");
                current[0].className = current[0].className.replace(" current", "");
                this.className += " current";
            });
        }
    }

    //SCROLL DOWN

    $('.nav__link__wrapper ul li a').on('click', function (e) {
        e.preventDefault();
        var href = $(this).attr('href');
        $('html, body').animate({
            scrollTop: $(href).offset().top - 20
        }, '1200');
    });

})(jQuery);